"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSvgToCimdoc = exports.convertSvgToCimdocSync = void 0;
const utility_cimdoc_1 = require("./utility.cimdoc");
const utility_svg_1 = require("./utility.svg");
const constants_1 = require("../constants");
const convertSvgToCimdocSync = ({ svgString, widthInMM, heightInMM, shouldMergePath, format, }) => {
    const parsedAbsolutePaths = utility_svg_1.loadSVG(svgString);
    const cimDocModules = shouldMergePath
        ? [
            utility_cimdoc_1.convertCimdocCommandsToCimDocModule({
                cimdocPathCommands: parsedAbsolutePaths
                    .map((absPath) => [...utility_cimdoc_1.convertPathCommandsToCimdoc(absPath.d)])
                    .reduce((cimdocCommands, currentCimdocCommand) => cimdocCommands.concat(currentCimdocCommand)),
                pathProperties: parsedAbsolutePaths.length > 0
                    ? parsedAbsolutePaths[0].pathProperties
                    : {
                        fill: constants_1.SvgDefaults.fillColor,
                        strokeWidth: `${constants_1.SvgDefaults.strokeWidth}`,
                        strokeColor: constants_1.SvgDefaults.strokeColor,
                    },
                widthInMM,
                heightInMM,
                format,
            }),
        ]
        : parsedAbsolutePaths.map((absPath) => {
            const cimdocCommand = utility_cimdoc_1.convertPathCommandsToCimdoc(absPath.d);
            return utility_cimdoc_1.convertCimdocCommandsToCimDocModule({
                cimdocPathCommands: cimdocCommand,
                pathProperties: absPath.pathProperties,
                widthInMM,
                heightInMM,
                format,
            });
        });
    return cimDocModules;
};
exports.convertSvgToCimdocSync = convertSvgToCimdocSync;
const convertSvgToCimdoc = ({ svgString, widthInMM, heightInMM, shouldMergePath, format, }) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        try {
            const res = exports.convertSvgToCimdocSync({
                svgString,
                widthInMM,
                heightInMM,
                shouldMergePath,
                format,
            });
            resolve(res);
        }
        catch (e) {
            reject(e);
        }
    });
});
exports.convertSvgToCimdoc = convertSvgToCimdoc;
//# sourceMappingURL=index.js.map